export const DEFAULT_MAX_MEETINGS_PER_MONTH = 2;

export const MAX_MEETINGS_PER_MONTH_RANGE = {
  min: 1,
  max: 10,
};
